//* Libraries imports
import React from "react";
import { Container } from "@mui/material";
import ReactTyped from "react-typed";

//* Components Imports
import ScrollTransition from "components/ScrollTransition";

//* Styles Imports
import styles from "./styles.module.css";

//* Assets Imports
import logo_black from "assets/static/logo/main_black.png";
import logo_white from "assets/static/logo/main_white.png";

function HeroSection(props) {
  return (
    <section
      id="hero-section"
      data-testid="hero-section"
      aria-label="Capa com logotipo e apresentação do cadastro de loja"
      className={styles.heroSection}
    >
      <Container
        id="hero-container"
        data-testid="hero-container"
        aria-label="Container principal da capa do cadastro"
        maxWidth="xl"
      >
        <div
          id="hero-content"
          data-testid="hero-content"
          aria-label="Conteúdo da capa de cadastro"
          className={styles.heroContent}
        >
          <ScrollTransition
            id="hero-logo-transition"
            data-testid="hero-logo-transition"
            aria-label="Animação de entrada do logotipo"
            delay={300}
            sx={{ display: "flex", justifyContent: "center", width: "100%" }}
          >
            <img
              id="hero-logo-img"
              data-testid="hero-logo-img"
              aria-label="Logotipo oficial do iGooB"
              src={`${props.dark_mode ? logo_black : logo_white}?v=1.1`}
              alt="Logotipo iGooB"
              className={styles.heroLogo}
            />
          </ScrollTransition>

          <ScrollTransition
            id="hero-title-transition"
            data-testid="hero-title-transition"
            aria-label="Animação de entrada do título principal"
            delay={450}
            sx={{ width: "100%" }}
          >
            <h1
              id="hero-title"
              data-testid="hero-title"
              aria-label="Título principal: Cadastre sua loja"
              className={styles.heroTitle}
            >
              <span
                id="hero-title-gold"
                data-testid="hero-title-gold"
                aria-label="Cadastre sua"
                className={styles.goldText}
              >
                Cadastre sua{" "}
              </span>
              <span
                id="hero-title-contrast"
                data-testid="hero-title-contrast"
                aria-label="Loja"
                className={styles.textContrast}
              >
                <ReactTyped
                  strings={["Loja", "Revenda", "Distribuidora", "Marca"]}
                  typeSpeed={70}
                  backSpeed={40}
                  backDelay={2500}
                  loop
                />
              </span>
            </h1>
          </ScrollTransition>

          <ScrollTransition
            id="hero-subtitle-transition"
            data-testid="hero-subtitle-transition"
            aria-label="Animação de entrada do subtítulo"
            delay={600}
            sx={{ width: "100%" }}
          >
            <p
              id="hero-subtitle"
              data-testid="hero-subtitle"
              aria-label="Subtítulo: Conecte sua loja ao maior ecossistema da construção civil"
              className={styles.heroSubtitle}
            >
              Chegue a milhares de compradores, gerencie vendas com rapidez e
              tenha integração inteligente com seu sistema.
            </p>
          </ScrollTransition>

          <ScrollTransition
            id="hero-btn-transition"
            data-testid="hero-btn-transition"
            aria-label="Animação de entrada do botão de ação"
            delay={750}
            sx={{ display: "flex", justifyContent: "center", width: "100%" }}
          >
            <button
              id="cta-register-btn"
              data-testid="cta-register-btn"
              aria-label="Quero me cadastrar no iGooB"
              onClick={() => window.open("https://painel.igoob.com.br", "_blank", "noopener,noreferrer")}
              className={styles.ctaScrollButton}
            >
              Quero me cadastrar
            </button>
          </ScrollTransition>
        </div>
      </Container>
    </section>
  );
}

export default HeroSection;
